// AddOplataModal.js
import React, { useState } from "react";
import axios from "axios";

const AddOplataModal = ({ isOpen, onClose, karnet, onAddOplata }) => {
  const [amount, setAmount] = useState(0);
  const [paymentDate, setPaymentDate] = useState(
    new Date().toISOString().split("T")[0]
  ); // Default to today
  const [note, setNote] = useState("");
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const token = localStorage.getItem("token"); // Pobierz token z localStorage

  const handleSubmit = async () => {
    const updatedKarnet = {
      ...karnet,
      karnet_oplacone: karnet.karnet_oplacone + parseFloat(amount),
      ilosc_rat: karnet.ilosc_rat > 0 ? karnet.ilosc_rat - 1 : 0,
    };

    const paymentData = {
      uzytkownik_id:
        typeof karnet.uzytkownik_id === "object"
          ? karnet.uzytkownik_id._id
          : karnet.uzytkownik_id,
      karnet_id: karnet.karnet_id ?? karnet._id,
      kwota: parseFloat(amount),
      data_platnosci: paymentDate,
      notatka: note,
    };

    try {
      // First, check if this karnet is in PaymentReminder and delete it if exists
      await axios.delete(
        `${BACKEND_URL}/api/payment/deletePaymentReminder/${paymentData.karnet_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      // Then proceed with normal payment addition
      onAddOplata(updatedKarnet, paymentData);
      setAmount(0);
      setPaymentDate(new Date().toISOString().split("T")[0]);
      setNote("");
      onClose();
    } catch (error) {
      console.error("Error processing payment:", error);
      // Even if reminder deletion fails, proceed with payment
      onAddOplata(updatedKarnet, paymentData);
      setAmount(0);
      setPaymentDate(new Date().toISOString().split("T")[0]);
      setNote("");
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>
      <div className="bg-white rounded-lg shadow-lg p-8 z-10 w-[480px]">
        <h2 className="text-2xl font-bold mb-6">Dodaj płatność</h2>

        <div className="space-y-6">
          {/* Aktualna kwota */}
          <div className="p-4 bg-gray-50 rounded-lg">
            <label className="block text-sm font-medium text-gray-700">
              Aktualna kwota opłacona:{" "}
              <span className="font-bold text-lg">
                {karnet.karnet_oplacone} PLN
              </span>
            </label>
          </div>

          {/* Display ilosc_rat and cena_za_rate if platnosc_rodzaj is "rata" */}
          {karnet.platnosc_rodzaj === "rata" && (
            <div className="p-4 bg-gray-50 rounded-lg">
              <label className="block text-sm font-medium text-gray-700">
                Ilość rat:{" "}
                <span className="font-bold text-lg">{karnet.ilosc_rat}</span>
              </label>
              <label className="block text-sm font-medium text-gray-700">
                Cena za ratę:{" "}
                <span className="font-bold text-lg">
                  {karnet.cena_za_rate} PLN
                </span>
              </label>
            </div>
          )}

          {/* Kwota wpłaty */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Kwota wpłaty
            </label>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="border border-gray-300 rounded-md p-2 w-full focus:ring-blue-500 focus:border-blue-500"
              required
              min="0"
              step="0.01"
            />
          </div>

          {/* Data płatności */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Data płatności
            </label>
            <input
              type="date"
              value={paymentDate}
              onChange={(e) => setPaymentDate(e.target.value)}
              className="border border-gray-300 rounded-md p-2 w-full focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>

          {/* Notatka */}
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Notatka
            </label>
            <textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              className="border border-gray-300 rounded-md p-2 w-full focus:ring-blue-500 focus:border-blue-500"
              rows="3"
              placeholder="Opcjonalny komentarz do płatności..."
            />
          </div>

          {/* Przyciski */}
          <div className="flex justify-end gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 rounded-md text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
            >
              Anuluj
            </button>
            <button
              onClick={handleSubmit}
              className="px-4 py-2 rounded-md text-white bg-blue-500 hover:bg-blue-600 transition-colors duration-200"
            >
              Dodaj płatność
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddOplataModal;
